import { ReactElement } from 'react';
import { EmbeddedCompany } from 'types';
import { BoundState, Breadcrumb, DatePartPickerField, UserField } from 'components';
import { usePeriod } from 'modules/reporting/usePeriod';
import { RowType, startColumns, endColumns, boundStateOptions } from './common';
import { SelectField } from '@ff-it/form';
import { CompanyField, CompanyTitle } from 'modules/core/company/components';
import { ReportTable } from 'components/ReportTable';
import { TableColumns } from '@ff-it/ui';

type ExpenseRowType = RowType & {
  provider: EmbeddedCompany;
};

const columns: TableColumns<ExpenseRowType> = [
  ...startColumns,
  {
    key: 'provider',
    content: 'Provider',
    render: ({ provider }) => <CompanyTitle {...provider} />,
    cellProps: {
      className: 'align-middle',
    },
  },
  ...endColumns,
  {
    key: 'state',
    width: 30,
    cellProps: {
      className: 'align-middle text-right',
    },
    render: ({ state, is_overspent }) => <BoundState variant="expense" state={state} is_overspent={is_overspent} />,
  },
];

export function ExpenseLinks(): ReactElement {
  const { date_from: minDate, date_to: maxDate } = usePeriod();
  return (
    <ReportTable
      url="invoicing/links/expense"
      columns={columns}
      filterFields={
        <>
          <Breadcrumb>Expense</Breadcrumb>
          <UserField
            name="manager"
            placeholder="Manager"
            className="ml-1"
            size="sm"
            simple
            filter={{ manage_campaign: true }}
          />
          <CompanyField
            name="provider"
            placeholder="Provider"
            className="ml-2"
            size="sm"
            simple
            includeBranches={true}
          />
          <SelectField name="state" placeholder="State" options={boundStateOptions} className="ml-2" size="sm" simple />
          <DatePartPickerField part="month" name="month" className="ml-2" minDate={minDate} maxDate={maxDate} />
        </>
      }
    />
  );
}
